import template from './moving-center-diy.html';
import { selectors } from '../../../../state';
import './moving-center-diy.global.css';

class MovingCenterDiyController {
  constructor(updStore) {
    'ngInject';
    Object.assign(this, { updStore });
  }

  $onInit() {
    this.disconnect = this.updStore.connect(mapStateToThis)(this);
  }

  $onDestroy() {
    this.disconnect();
  }
}

export const MovingCenterDiyComponent = {
  template,
  transclude: true,
  controller: MovingCenterDiyController,
  bindings: {
    headerTitle: '@',
    headerSubtitle: '@',
  },
};

function mapStateToThis(state) {
  return {
    moveId: selectors.current.move(state).id(state),
  };
}
